<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="content-t" id="calibre_toc_1"><span class="char-style-override">Real Life Organizing</span><span class="normal-caps"></span></p>
<p class="chapter-number"><span class="char-style-override1">Clean and Clutter-Free in 15 Minutes a Day</span><span class="normal-caps1"></span></p>
<p class="name">Cassandra Aarssen<span class="normal-caps2"></span></p>
<p class="image-aa"><span><img alt="MangoLogo.png" class="frame" src="OEBPS/image/MangoLogo_fmt.png"/></span><span class="normal-caps"> </span></p>
<div class="calibre2" id="calibre_pb_0"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RealLifeOrg_split_000.vue?d3b1a9d6